<template>
  <div class="row">
    <div class="col-md-12 pt-0 text-danger">
      Todas as informações são obrigatórias!
    </div>

    <!-- inputs padrões -->
    <div class="input-container-modern container">
      <div class="input-item-modern">
        <v-select
          v-model="type"
          :items="[
            { value: 'DIARIA', description: 'DIÁRIA' },
            { value: 'MENSAL', description: 'MENSAL' },
          ]"
          label="PLANO"
          dense
          outlined
          item-value="value"
          item-text="description"
          @input="handleInputType"
        />
      </div>

      <div class="input-item-modern">
        <v-text-field
          v-model="due_date"
          :label="
            type == 'DIARIA'
              ? 'Vencimento da mensalidade'
              : 'Vencimento da 1ª mensalidade'
          "
          outlined
          dense
          type="date"
          @input="handleInputDueDate"
        />
      </div>

      <div class="input-item-modern">
        <v-text-field
          v-model="value"
          :label="type == 'DIARIA' ? 'Valor da diária' : 'Valor da mensalidade'"
          outlined
          dense
          @input="handleValueDaily"
        />
      </div>

      <div class="input-item-modern" v-if="type == 'DIARIA'">
        <v-select
          v-model="daily_amount"
          :items="daily_amounts"
          label="Quantidade de diárias"
          dense
          outlined
          item-value="value"
          item-text="description"
          @change="handleValueDailyAmount"
        />
      </div>

      <div class="input-item-modern" v-if="type == 'DIARIA'">
        <v-text-field
          disabled
          label="Total do período"
          :value="formatValueOnKeyUp(String(total_daily_value))"
          outlined
          dense
        />
      </div>

      <div class="input-item-modern" v-if="type == 'MENSAL'">
        <v-select
          :disabled="!due_date || !value"
          v-model="number_of_installments"
          :items="parcel_numbers"
          label="Quantidade de parcelas"
          dense
          outlined
          item-value="value"
          item-text="description"
          @change="handleValueNumberOfInstallments"
        />
      </div>

      <div class="input-item-modern">
        <LabelRequiredField label="CONTA:" />

        <v-select
          v-model="account_id"
          :items="
            finance_configuration_account.map((account) => ({
              value: account.id,
              description: account.finance_configuration_grouping_description
                ? `${account.finance_configuration_grouping_description} / ${account.account_nickname}`
                : `${account.account_nickname}`,
            }))
          "
          dense
          outlined
          item-value="value"
          item-text="description"
        />
      </div>

      <div class="input-item-modern input-category">
        <label class="form-label-modern">CATEGORIA:</label>

        <treeselect
          :options="finance_configuration_category"
          placeholder="Categoria"
          v-model="finance_configuration_category_id"
          noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
        />
      </div>

      <div class="input-item-modern">
        <label class="form-label-modern">CENTRO DE CUSTO:</label>
        <v-select
          v-model="finance_configuration_profit_cost_center_id"
          :items="[
            { value: null, description: 'Centro de Custo' },
            ...finance_configuration_profit_cost_center.map((center) => ({
              value: center.id,
              description: center.description,
            })),
          ]"
          dense
          outlined
          item-value="value"
          item-text="description"
          placeholder="Centro de custo"
        />
      </div>

      <div class="input-item-modern">
        <label class="form-label-modern">FORMA DE PAGAMENTO:</label>

        <v-select
          v-model="finance_configuration_payment_methods_id"
          :items="[
            { value: null, description: 'Forma de pagamento' },
            ...finance_configuration_payment_methods.map((method) => ({
              value: method.id,
              description: method.description,
            })),
          ]"
          dense
          outlined
          item-value="value"
          placeholder="Forma de pagamento"
          item-text="description"
        />
      </div>

      <div class="input-item-modern">
        <label class="form-label-modern">TIPO DE CUSTO:</label>

        <v-select
          v-model="cost_type"
          :items="[
            { value: null, description: 'Tipo de Custo' },
            ...cost_types.map((type) => ({
              value: type.value,
              description: type.description,
            })),
          ]"
          dense
          outlined
          item-value="value"
          placeholder="Tipo de custo"
          item-text="description"
        />
      </div>

      <div class="input-item-modern">
        <label class="form-label-modern">APROPRIAÇÃO DE CUSTO:</label>

        <v-select
          v-model="cost_appropriation"
          :items="[
            { value: null, description: 'Apropriação de Custo' },
            ...cost_appropriations.map((appropriation) => ({
              value: appropriation.value,
              description: appropriation.description,
            })),
          ]"
          dense
          outlined
          item-value="value"
          placeholder="Apropriação de custo"
          item-text="description"
        />
      </div>
    </div>

    <div class="col-md-12 pt-0 pb-0" v-if="type == 'MENSAL'">
      <hr class="mt-0" v-if="items.length > 0" />

      <div class="row" v-for="(item, key) in items" :key="key">
        <div class="col-md-3 pt-0 pb-0">
          <v-text-field
            disabled
            label=""
            outlined
            dense
            type="text"
            :value="`${key + 1}ª PARCELA`"
          />
        </div>

        <div class="col-md-3 pt-0 pb-0">
          <v-text-field
            label="Vencimento"
            outlined
            dense
            type="date"
            v-model="item.due_date"
          />
        </div>

        <div class="col-md-3 pt-0 pb-0">
          <v-text-field
            label="Valor"
            outlined
            dense
            type="text"
            v-model="item.value"
            @input="item.value = formatValueOnKeyUp(String(item.value))"
          />
        </div>

        <div class="col-md-3 pt-0 pb-0">
          <v-text-field
            label="Observação"
            outlined
            dense
            type="text"
            v-model="item.note"
          />
        </div>
      </div>
    </div>

    <div class="col-md-12 pt-0"><hr class="m-0" /></div>

    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>

    <div class="col-md-12 pt-0 pb-0 text-right">
      <confirmation-dialog
        headerClass="modal-header-modern"
        message-title="Deseja realmente lançar?"
        message-body=""
        openText="LANÇAR"
        open-class="btn-modern btn-modern-save"
        open-left-icon="fa-check"
        @yes="execute"
        :disabled="btnExecute || loadingExecute"
        :loading="loadingExecute"
      />
    </div>
  </div>
</template>

<script>
import LabelRequiredField from "../../../Components/LabelRequiredField";

import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import ConfirmationDialog from "../../../Components/ConfirmationDialog.vue";

import Treeselect from "@riophae/vue-treeselect";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import { formatValueOnKeyUp, numbersOnly } from "../../../../lib/format";

import moment from "moment";

export default {
  name: "New",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    LabelRequiredField,
    Treeselect,
  },

  computed: {
    btnExecute() {
      let { type, items, due_date, value } = this;

      if (!type) {
        return true;
      }

      if (type == "MENSAL") {
        if (items.length == 0) {
          return true;
        }

        for (let item of items) {
          if (!item.value || !item.due_date) {
            return true;
          }
        }
      }

      if (type == "DIARIA") {
        if (!due_date) {
          return true;
        }

        if (!value || value == "0,00") {
          return true;
        }
      }

      return false;
    },
  },

  props: {
    resident_id: [String, Number],
  },

  data() {
    return {
      account_id: null,

      finance_configuration_category_id: null,

      finance_configuration_profit_cost_center_id: null,

      finance_configuration_payment_methods_id: null,

      cost_type: null,

      cost_appropriation: null,

      finance_configuration_account: [],

      finance_configuration_category: [],

      finance_configuration_profit_cost_center: [],

      finance_configuration_payment_methods: [],

      cost_types: [
        { value: "FIXO", description: "FIXO" },
        { value: "VARIAVEL", description: "VARIÁVEL" },
      ],

      cost_appropriations: [
        { value: "DIRETO", description: "DIRETO" },
        { value: "INDIRETO", description: "INDIRETO" },
      ],

      type: "MENSAL",

      value: "",

      daily_amount: 1,

      daily_amounts: [],

      total_daily_value: 0,

      number_of_installments: "",

      parcel_numbers: [],

      due_date: "",

      data: [],

      total: 0,

      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "PLANO", value: "plan", sortable: false },
        { text: "INFORMAÇÕES", value: "information", sortable: false },
        { text: "AÇÕES", value: "actions", sortable: false },
      ],

      expanded: [],

      items: [],

      loading: false,

      loadingExecute: false,

      loadingPay: false,

      loadingDelete: false,

      errors: [],
    };
  },

  async created() {
    await this.financeConfigurationAccount();

    await this.financeConfigurationCategory();

    await this.financeConfigurationProfitCostCenter();

    await this.financeConfigurationPaymentMethods();

    for (let i = 1; i <= 27; i++) {
      this.daily_amounts.push({ value: i, description: i });
    }

    this.parcel_numbers.push({ value: "", description: "SELECIONE..." });

    for (let i = 1; i <= 14; i++) {
      this.parcel_numbers.push({
        value: i,
        description: `${i} ${i == 1 ? "PARCELA" : "PARCELAS"}`,
      });
    }
  },

  methods: {
    formatValueOnKeyUp,

    handleInputType(value) {
      this.items = [];
      this.number_of_installments = "";
      this.daily_amount = 1;
      if (value == "DIARIA") {
        this.handleTotalValueDaily();
      }
    },

    handleTotalValueDaily() {
      let { value, daily_amount } = this;

      if (daily_amount && value) {
        this.total_daily_value = daily_amount * numbersOnly(value);
      }
    },

    handleValueDailyAmount() {
      this.handleTotalValueDaily();
    },

    handleValueDaily(value) {
      this.value = formatValueOnKeyUp(numbersOnly(value));
      this.items.map((item) => (item.value = this.value));
      this.handleTotalValueDaily();
    },

    handleInputDueDate(due_date) {
      if (due_date) {
        if (this.items.length > 0) {
          this.items.map(
            (item, key) =>
              (item.due_date =
                key == 0
                  ? due_date
                  : moment(due_date).add(key, "months").format("YYYY-MM-DD"))
          );
        }
      }
    },

    handleValueNumberOfInstallments(value) {
      if (value) {
        let items = [];

        let { due_date } = this;

        for (let i = 1; i <= parseInt(value); i++) {
          items.push({
            value: this.value,
            due_date: due_date
              ? i == 1
                ? due_date
                : moment(due_date)
                    .add(i - 1, "months")
                    .format("YYYY-MM-DD")
              : "",
            note: "",
          });
        }
        this.items = items;
      } else {
        this.items = [];
      }
    },

    async execute() {
      try {
        this.loadingExecute = true;

        let {
          resident_id,
          type, // MENSAL|DIARIA
          number_of_installments, // Quantidade de parcelas
          value, // Valor da mensalidade/diária
          daily_amount, // Quantidade de diárias
          due_date, //  type == 'DIARIA' ? 'Vencimento da mensalidade' : 'Vencimento da 1ª mensalidade';
          items, // Parcelas - MENSAL
          total_daily_value,
          account_id, // CONTA ID
          finance_configuration_category_id, // CATEGORIA ID
          finance_configuration_profit_cost_center_id, //CENTRO DE CUSTO ID
          finance_configuration_payment_methods_id, // FORMA DE PAGAMENTO
          cost_type, //TIPO DE CUSTO
          cost_appropriation, //APROPRIAÇÃO DE CUSTO
        } = this;

        let params = {
          resident_id,
          type,
          number_of_installments,
          value,
          daily_amount,
          due_date,
          items,
          total_daily_value: formatValueOnKeyUp(String(total_daily_value)),
          account_id,
          finance_configuration_category_id,
          finance_configuration_profit_cost_center_id,
          finance_configuration_payment_methods_id,
          cost_type,
          cost_appropriation,
        };

        const response = await api.post(
          "/rest-home/resident-accommodation",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          toast(message, "success");
          this.$emit("success");
          this.errors = [];
          this.items = [];
          this.type = "MENSAL";
          this.value = "";
          this.daily_amount = 1;
          this.total_daily_value = 0;
          this.number_of_installments = "";
          this.due_date = "";
        } else {
          this.errors = errors;
        }

        this.loadingExecute = false;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationAccount() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/account-actives"
        );

        const { data } = response.data;

        let finance_configuration_account = [];

        for (let account of data) {
          finance_configuration_account.push(account);

          if (account.default == 1) {
            this.account_id = account.id;
          }
        }

        this.finance_configuration_account = finance_configuration_account;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationCategory() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/category-actives"
        );

        const { data } = response.data;

        let finance_configuration_category = [];

        for (let category of data) {
          finance_configuration_category.push(category);

          if (category.default == 1) {
            this.finance_configuration_category_id = category.id;
          }
        }

        this.finance_configuration_category = finance_configuration_category;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationProfitCostCenter() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/profit-cost-center-actives"
        );

        const { data } = response.data;

        this.finance_configuration_profit_cost_center = data;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationPaymentMethods() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/payment-methods-actives"
        );

        const { data } = response.data;

        this.finance_configuration_payment_methods = data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.treeselect:hover,
.treeselect:focus {
  background-color: #ffffff !important;
}

.header {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 24px 32px;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(240, 240, 240, 0.5);
  transition: all 0.3s ease;
}

.header:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.input-container-modern {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.input-item-modern {
  flex: 1 1 calc(25% - 20px);
  min-width: 180px;
  max-width: calc(25% - 20px);
}

.input-category {
  margin-top: 10px;
}

.form-label-modern {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
  display: block;
}

.modal-header-modern {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid #e5e7eb;
  padding: 20px 24px;
  border-radius: 12px 12px 0 0;
}

.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 14px 32px;
  font-weight: 600;
  text-transform: none;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3);
  transition: all 0.3s ease;
}

.btn-save-modern:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4);
}

.btn-save-modern:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.errors-section-modern {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fca5a5;
  border-radius: 12px;
  padding: 16px;
}

@media (max-width: 768px) {
  .header {
    padding: 16px 24px;
    border-radius: 16px;
  }
}
</style>